



































import { Vue, Component } from 'vue-property-decorator';
import { FileType } from '@/common/ts/enum';
import Uploader from '@/components/Uploader.vue';
import { saveData } from './api';
import { Toast, Popup, Dialog } from 'vant';
import { autoOpenApp } from '@/common/ts/common';
import { appShare, wxShareInfo, isWeiXin } from '@/common/ts/common';
Vue.use(Toast);
@Component({
  components: {
    Uploader,
  },
})
export default class SignUp extends Vue {
  pointOut = false;
  cover: any = '';
  team: any = '';
  name: any = '';
  tel: any = '';
  desc: any = '';
  FileType = FileType;
  getOssImagesUrls(result: any) {
    this.cover = result;
    console.log('result', result, this.cover);
  }
  submitContent() {
    if (isWeiXin() === true) {
      Dialog.confirm({
        title: '友情提示',
        message: '请在上游新闻App进行投票',
        confirmButtonText: '还没装？一步安装',
        cancelButtonText: '我已安装过',
        closeOnClickOverlay: true,
      })
        .then(() => {
          window.location.href =
            'http://a.app.qq.com/o/simple.jsp?pkgname=com.news.shangyounews';
        })
        .catch(() => {
          if (isWeiXin() === true) {
            this.pointOut = true;
          } else {
            window.location.href =
              'shangyounews://{"dt":"7","url":"' +
              document.location.href +
              '"}';
          }
        });
    } else {
      if (window.udid) {
        if (this.name === '') {
          return Toast({
            type: 'fail',
            duration: 3000,
            message: '请输入作者名称',
          });
        }
        if (this.team === '') {
          return Toast({
            type: 'fail',
            duration: 3000,
            message: '请输入团队名称',
          });
        }
        if (this.tel === '') {
          return Toast({
            type: 'fail',
            duration: 3000,
            message: '请输入手机号码',
          });
        } else if (!/^[1][3,4,5,7,8,9,6][0-9]{9}$/.test(this.tel)) {
          return Toast({
            type: 'fail',
            duration: 3000,
            message: '请输入正确的手机号码',
          });
        }
        if (this.desc === '') {
          return Toast({
            type: 'fail',
            duration: 3000,
            message: '请输入团队介绍',
          });
        }
        if (this.cover === '') {
          return Toast({
            type: 'fail',
            duration: 3000,
            message: '请上传图片',
          });
        }
        if (this.name && this.team && this.tel && this.cover && this.desc) {
          const data = {
            title: this.team,
            subtitle: this.name,
            tailTitle: this.tel,
            cover: this.cover,
            content: this.desc,
            udid: window.udid,
            appkey: window.appkey,
          };
          console.log(data);
          saveData(data).then((res: any) => {
            Toast({
              type: 'success',
              duration: 3000,
              message: res.msg,
            });
            console.log(res.data);
            this.$router.go(0);
          });
        }
      }
    }
  }

  created() {
    autoOpenApp();
    // 分享
    appShare({
      title: 'Break the Limit-创·无界首届国际青年短视频大赛',
      url: window.location.href,
      subtitle: 'Break the Limit-创·无界首届国际青年短视频大赛',
      classId: -1,
      id: -1,
      image: 'http://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg',
      type: 3,
    });
    wxShareInfo({
      title: 'Break the Limit-创·无界首届国际青年短视频大赛',
      subtitle: 'Break the Limit-创·无界首届国际青年短视频大赛',
      image: 'http://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg',
    });
  }
}
